import React from 'react';
import './ThankYou.css';
import { FaCheckCircle, FaEnvelope, FaCalendarAlt, FaRocket, FaClock } from 'react-icons/fa';
import { useSearchParams, useNavigate } from 'react-router-dom';

const ThankYou = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const sessionId = searchParams.get('session_id');
    const bookedDate = searchParams.get('booked_date');
    const bookedTime = searchParams.get('booked_time');
    const bookedSlotsParam = searchParams.get('booked_slots');

    let bookedSlots = [];
    try {
        if (bookedSlotsParam) {
            bookedSlots = JSON.parse(bookedSlotsParam);
        } else if (bookedDate && bookedTime) {
            bookedSlots = [{ date: bookedDate, time: bookedTime }];
        }
    } catch (e) {
        console.error('Error parsing booked slots:', e);
    }

    if (!sessionId) {
        return (
            <div className="thank-you-container">
                <div className="thank-you-header-gradient" />
                <div className="thank-you-content">
                    <div className="error-message">
                        <h2>Invalid Session</h2>
                        <p>Please complete payment first.</p>
                        <button onClick={() => navigate('/tutoring')} className="back-btn">
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="thank-you-container">
            <div className="thank-you-header-gradient" />

            <div className="thank-you-content">
                <div className="thank-you-card">
                    <div className="success-animation">
                        <FaCheckCircle className="check-icon" />
                    </div>

                    {bookedSlots.length > 0 ? (
                        <>
                            <h1>Booking Confirmed!</h1>
                            <p className="subtitle">Your {bookedSlots.length} session{bookedSlots.length > 1 ? 's are' : ' is'} scheduled</p>

                            <div className="confirmed-slots-list">
                                {bookedSlots.map((slot, index) => (
                                    <div key={index} className="confirmed-slot">
                                        <div className="confirmed-date">
                                            <FaCalendarAlt />
                                            <span>{slot.date}</span>
                                        </div>
                                        <div className="confirmed-time">
                                            <FaClock />
                                            <span>{slot.time} CT</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <>
                            <h1>Welcome to the Program!</h1>
                            <p className="subtitle">Your enrollment is confirmed</p>

                            <div className="info-cards">
                                <div className="info-card">
                                    <FaEnvelope className="info-icon" />
                                    <div>
                                        <h3>Check Your Email</h3>
                                        <p>We'll send you all the details within 24 hours</p>
                                    </div>
                                </div>

                                <div className="info-card">
                                    <FaCalendarAlt className="info-icon" />
                                    <div>
                                        <h3>Mark Your Calendar</h3>
                                        <p>Feb 28 - May 2, Every Saturday 11 AM - 2 PM CT</p>
                                    </div>
                                </div>

                                <div className="info-card">
                                    <FaRocket className="info-icon" />
                                    <div>
                                        <h3>Get Ready to Learn</h3>
                                        <p>We'll be in touch with pre-work materials soon</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <div className="next-steps">
                        <h3>What happens next?</h3>
                        <ul>
                            <li>You'll receive a confirmation email with your receipt</li>
                            <li>You'll receive a confirmation email with your receipt</li>
                            {bookedSlots.length > 0 ? (
                                <li>You'll receive a calendar invite and Zoom link shortly</li>
                            ) : (
                                <>
                                    <li>Within 24 hours, we'll send program details and onboarding instructions</li>
                                    <li>Get access to our private Discord/Slack for program participants</li>
                                    <li>Start with pre-work materials before the first session</li>
                                </>
                            )}
                        </ul>
                    </div>

                    <div className="contact-note">
                        <p>Questions? Reply directly to any email from us, or reach out at <strong>divyesh.thirukonda@gmail.com</strong></p>
                    </div>

                    <button onClick={() => navigate('/tutoring')} className="home-btn">
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ThankYou;
